import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { UtilityService } from '@nttp/common-service/utility-service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';


function comparePass(c: AbstractControl) {
  const v = c.value;
  return v.newPassword === v.confirmNewPassword
    ? null
    : {
      passnotmatch: true
    };
}

@Component({
  selector: 'np-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  passwordPattern = '^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[(!@#$%^&*()_+|~ ={}[:”;<>?,., )]).{8,}$';
  constructor(
    private fb: FormBuilder,
    private commonService: UtilityService,
    private authService: AuthService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmNewPassword: ''
    },
      {
        validator: [comparePass]
      });
  }

  changePassword() {
    this.changePasswordForm.markAllAsTouched();
    if (this.changePasswordForm.valid) {
      const params = {
        oldPassword: this.changePasswordForm.get('oldPassword').value,
        newPassword: this.changePasswordForm.get('newPassword').value,
        confirmNewPassword: this.changePasswordForm.get('confirmNewPassword').value,
      };
      this.commonService.updatePassword(params).subscribe(res => {
        const dialogRef = this.dialog.open(CommonDialogComponent, {
          disableClose: true,
          data: {
            title: 'The password has changed.<br> You must re-login again.',
            dialogType: 1,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.authService.logout();
        });
      });
    }
  }
}
